module.exports = __webpack_public_path__ + "static/media/recibo_de_entrega.a8ab92aa.png";